import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import PhoneService from 'services/Phone'
import { FaWhatsapp } from 'react-icons/fa'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  SubTitle,
  InfoText,
  LinkText,
  MoneyTextMask,
} from '../styles'

export default function CustomerPersonalInfo ({ customer }) {
  const [loading, setLoading] = useState (true)
  const [customerData, setCustomerData] = useState (customer)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getCustomer ()
  }, [customer])

  const getCustomer = async () => {
    try {
      setLoading (true)

      const { data: customerResponse } = await cutileiApi.get (
        `/businesses/${businessId}/customers?customer_id=${customer?.id}`,
        requestConfig
      )

      setCustomerData (customerResponse.data[0])
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  if (loading) return (
    <Container>
      <Loading style={{marginBottom: 20}}/>
    </Container>
  )

  return (
    <Container style={{marginBottom: 20}}>
      <Row>
        <SubTitle>Nome:</SubTitle>
        <InfoText>{customerData.name}</InfoText>
      </Row>
      {customerData.email && (
        <Row>
          <SubTitle>E-mail:</SubTitle>
          <InfoText>{customerData.email}</InfoText>
        </Row>
      )}
      {customerData.phone && (
        <Row>
          <SubTitle>Celular:</SubTitle>
          <InfoText>
            {PhoneService.formatPhone (customerData.phone)}
          </InfoText>
          <LinkText href={`https://api.whatsapp.com/send?phone=55${customerData.phone}`} target='_blank'>
            <FaWhatsapp size={18} color='#44CF6C'/>
            Falar com cliente
          </LinkText>
        </Row>
      )}
      {customerData.gender && (
        <Row>
          <SubTitle>Gênero:</SubTitle>
          <InfoText>{customerData.gender}</InfoText>
        </Row>
      )}
      {customerData.birth && (
        <Row>
          <SubTitle>Data de nascimento:</SubTitle>
          <InfoText>
            {DateTime.fromISO (customerData.birth).toFormat ('dd/MM/yyyy')}
          </InfoText>
        </Row>
      )}
      <Row>
        <SubTitle>Saldo do cliente:</SubTitle>
        <MoneyTextMask value={customerData.balance || 0}/>
      </Row>
    </Container>
  )
}
